(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Lootroom: the cart-drawer trigger is bound once, in cart-drawer.js. A second binding here opened
     the drawer twice per click (audit JS-5). */
  (function () {
    /* Escape blurs the focused header search input so the
       predictive-search dropdown closes without a click. */
    const input = document.querySelector('[data-header-search-input]');
    if (!input) return;
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && document.activeElement === input) {
        input.blur();
      }
    });
  })();

  (function () {
    /* Combined locale switcher: native <details> handles open/close; this adds
       outside-click + Escape close, focuses the country filter on open, and wires
       the country search + keyboard nav (the country list can be ~200 rows). */
    const sw = document.querySelector('[data-locale-switcher]');
    if (!sw) return;
    const btn = sw.querySelector('.locale-switcher__btn');
    const filter = sw.querySelector('[data-ls-filter]');
    const rows = sw.querySelectorAll('[data-ls-row]');
    const empty = sw.querySelector('[data-ls-empty]');

    function visibleOpts() {
      return [...rows].filter(function (r) { return !r.hidden; })
        .map(function (r) { return r.querySelector('.locale-switcher__opt'); });
    }
    function close() {
      if (!sw.open) return;
      sw.open = false;
      if (filter) {
        filter.value = '';
        rows.forEach(function (r) { r.hidden = false; });
        if (empty) empty.hidden = true;
      }
    }
    function applyFilter() {
      const q = filter.value.trim().toLowerCase();
      let shown = 0;
      rows.forEach(function (r) {
        const match = !q || r.dataset.search.indexOf(q) !== -1;
        r.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }

    document.addEventListener('click', function (e) {
      if (sw.open && !sw.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sw.open) { close(); if (btn) btn.focus(); }
    });
    sw.addEventListener('toggle', function () {
      if (sw.open && filter) filter.focus();
    });

    if (filter) {
      filter.addEventListener('input', applyFilter);
      filter.addEventListener('keydown', function (e) {
        const opts = visibleOpts();
        if (e.key === 'ArrowDown' && opts.length) { e.preventDefault(); opts[0].focus(); }
        else if (e.key === 'Enter' && opts.length) { e.preventDefault(); opts[0].click(); }
      });
    }
    rows.forEach(function (r) {
      const opt = r.querySelector('.locale-switcher__opt');
      if (!opt) return;
      opt.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        const opts = visibleOpts();
        const idx = opts.indexOf(opt);
        if (e.key === 'ArrowDown' && opts[idx + 1]) opts[idx + 1].focus();
        else if (e.key === 'ArrowUp') { if (idx === 0 && filter) filter.focus(); else if (opts[idx - 1]) opts[idx - 1].focus(); }
      });
      // Spanish-speaking country → also switch the language to Spanish. The row
      // carries data-ls-lang from Liquid; set the country form's hidden locale_code
      // just before the native submit, so one click switches both country + language
      // (verified: locale_code=es + country_code=AR together serves /es in Argentina).
      const couple = r.getAttribute('data-ls-lang');
      if (couple) {
        opt.addEventListener('click', function () {
          const form = opt.closest('form');
          const hidden = form && form.querySelector('input[name="locale_code"]');
          if (hidden) hidden.value = couple;
        });
      }
    });
  })();

  (function () {
    const drawer = document.getElementById('HeaderDrawer');
    const backdrop = document.querySelector('[data-header-drawer-backdrop]');
    const openButtons = document.querySelectorAll('[data-header-drawer-open]');
    const closeButtons = document.querySelectorAll('[data-header-drawer-close]');

    if (!drawer || !backdrop) return;

    let lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.remove('no-transition');
      backdrop.classList.remove('no-transition');
      drawer.classList.add('header__drawer--open');
      // Must come off before trapFocus below — an inert subtree cannot take focus.
      drawer.removeAttribute('inert');
      backdrop.hidden = false;
      requestAnimationFrame(function () {
        backdrop.classList.add('header__drawer-backdrop--open');
      });
      document.body.style.overflow = 'hidden';
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      const firstLink = drawer.querySelector('a, button, input');
      // Fokus-Trap: Dawns trapFocus (global.js, defer im head — laeuft vor
      // diesem Section-Bundle) haelt Tab im Drawer statt in die scroll-
      // gesperrte Seite dahinter zu wandern (audit-2026-06 A11Y-3).
      if (typeof trapFocus === 'function') {
        trapFocus(drawer, firstLink || drawer);
      } else if (firstLink) {
        firstLink.focus();
      }
    }

    function close() {
      drawer.classList.remove('header__drawer--open');
      backdrop.classList.remove('header__drawer-backdrop--open');
      document.body.style.overflow = '';
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { backdrop.hidden = true; }, 300);
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(lastFocus && typeof lastFocus.focus === 'function' ? lastFocus : null);
      } else if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
      // After the focus restore, not before: making the subtree inert while
      // focus is still inside it drops focus to <body> for a frame.
      drawer.setAttribute('inert', '');
    }

    openButtons.forEach(function (b) { b.addEventListener('click', open); });
    closeButtons.forEach(function (b) { b.addEventListener('click', close); });
    backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('header__drawer--open')) close();
    });

    const mq = window.matchMedia('(min-width: 1025px)');
    function handleResize(e) {
      if (e.matches && drawer.classList.contains('header__drawer--open')) close();
    }
    if (mq.addEventListener) mq.addEventListener('change', handleResize);
    else mq.addListener(handleResize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('[data-hero]');
    heroes.forEach(function (hero) {
      const slides = hero.querySelectorAll('[data-hero-slide]');
      const dots = hero.querySelectorAll('[data-hero-dot]');
      const prev = hero.querySelector('[data-hero-prev]');
      const next = hero.querySelector('[data-hero-next]');
      const autoRotate = hero.dataset.autoRotate === 'true';
      const rotationMs = parseInt(hero.dataset.rotationMs, 10) || 6000;

      // Pause flags for the rotation clock (see tick() below). Declared before
      // the IntersectionObserver so offscreen state feeds the clock too.
      // NOTE deliberately no hover pause: the hero fills the viewport on
      // load, so the cursor rests on it constantly — pausing on hover meant
      // rotation effectively never ran for mouse users (the original
      // "es wechselt gar nicht" complaint, and after the clock rewrite a
      // visibly frozen bar). Mouse users keep control via arrows/dots.
      let keyboardFocusInside = false;
      let offscreen = false;

      // Freeze the hero's purely-decorative continuous animations (bob, floor
      // shadow, background drift, swipe nudge) while it's scrolled out of
      // view — they cost GPU/battery for nothing off-screen. Toggles the
      // .is-offscreen class the CSS hooks, and pauses the rotation clock.
      // Runs for every hero (before the single-slide early return) so it
      // applies regardless of slide count.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            offscreen = !entry.isIntersecting;
            hero.classList.toggle('is-offscreen', offscreen);
          });
        }).observe(hero);
      }

      if (slides.length < 2) return;

      // Mobile swipe hint: dismiss on the first touch (and after a timeout) so
      // it doesn't linger once the user knows the hero is swipeable.
      const swipeHint = hero.querySelector('[data-hero-swipe-hint]');
      if (swipeHint) {
        const dismissSwipeHint = function () { swipeHint.classList.add('is-dismissed'); };
        hero.addEventListener('touchstart', dismissSwipeHint, { once: true, passive: true });
        window.setTimeout(dismissSwipeHint, 7000);
      }

      let current = 0;

      // Neighbour previews (≥1400px, see markup). Roles follow the active
      // slide; images are promoted lazy → eager only when the previews can
      // actually be seen, so phones/laptops never download them.
      const peeks = hero.querySelectorAll('[data-hero-peek]');
      const wideMq = window.matchMedia('(min-width: 1400px)');
      function updatePeeks(i) {
        if (!peeks.length) return;
        const n = slides.length;
        const nx = (i + 1) % n;
        const pv = (i - 1 + n) % n;
        peeks.forEach(function (p) { p.removeAttribute('data-peek-role'); });
        peeks[nx].setAttribute('data-peek-role', 'next');
        if (pv !== nx) peeks[pv].setAttribute('data-peek-role', 'prev');
        if (wideMq.matches) {
          loadSlideImages(peeks[nx]);
          loadSlideImages(peeks[pv]);
        }
      }

      // Art/logo images on non-first slides ship as loading="lazy". A lazy
      // image inside a display:none slide does NOT reliably load when the slide
      // is later switched to display:grid, so rotating to it left a blank art
      // stage (e.g. slide 3's product missing on mobile). Promote a slide's
      // lazy images to eager so the picture is there before/when it's shown.
      function loadSlideImages(slide) {
        if (!slide) return;
        slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      }

      // ---- Native scroll-snap mode (≤980px, 17.09) ----
      // On phones/tablets the slides sit side by side in a CSS scroll-snap
      // scroller (see section-hero.css): the browser moves them with the
      // finger, flings and snaps natively. The script no longer animates
      // anything there — it READS the scroll position (dots, aria, rotation
      // clock) and WRITES it via scrollTo() for dots and auto-rotation.
      // Above 980px the old display-swap stays (arrows, peeks).
      const slidesEl = hero.querySelector('.hero__slides');
      const snapMq = window.matchMedia('(max-width: 980px)');
      let userTouching = false;
      let programmaticScroll = false;
      let scrollSettleTimer = null;

      // Reduced motion: the rotation itself stays ungated (policy, see
      // rotationBlocked below) — only the ANIMATED programmatic scroll turns
      // into an instant jump. Finger scrolling is native either way.
      const reduceMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');

      // State only: which slide is "the" slide (aria, dots, peeks, images).
      // `warm` = also promote this + the next slide's lazy images to eager.
      function setActive(i, warm) {
        const snap = snapMq.matches;
        slides.forEach(function (s, idx) {
          s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
          // In snap mode every slide is rendered; keep the off-screen ones
          // out of the tab order and the accessibility tree.
          s.inert = snap && idx !== i;
        });
        dots.forEach(function (d, idx) {
          d.setAttribute('aria-current', idx === i ? 'true' : 'false');
        });
        current = i;
        // Load the shown slide now + warm the next one so the swap is seamless.
        if (warm !== false) {
          loadSlideImages(slides[i]);
          loadSlideImages(slides[(i + 1) % slides.length]);
        }
        updatePeeks(i);
      }

      // State follows position: whatever slide the scroller rests on is the
      // active one. Runs 140ms after the last scroll event, and as a 1.5s
      // watchdog after every scrollTo() — if a scrollTo() yields no scroll
      // events (already there, or a browser swallowing it inside a mandatory
      // snap container), the visible slide must not stay inert.
      function reconcile() {
        programmaticScroll = false;
        if (!slidesEl || !snapMq.matches) return;
        const w = slidesEl.clientWidth || 1;
        const settled = Math.max(0, Math.min(slides.length - 1, Math.round(slidesEl.scrollLeft / w)));
        if (settled !== current) setActive(settled);
      }

      function scrollToSlide(i, smooth) {
        if (!slidesEl) return;
        const left = slides[i].offsetLeft - slides[0].offsetLeft;
        if (Math.abs(slidesEl.scrollLeft - left) < 1) return; // already there: don't arm the flag
        programmaticScroll = true;
        slidesEl.scrollTo({
          left: left,
          behavior: (smooth && !reduceMotionMq.matches) ? 'smooth' : 'auto'
        });
        window.clearTimeout(scrollSettleTimer);
        scrollSettleTimer = window.setTimeout(reconcile, 1500);
      }

      // State + position: used by dots, arrows, peeks and the rotation clock.
      function show(i) {
        const prev = current;
        setActive(i);
        // Glide only between neighbours. The wrap-around (last → first, or
        // first → last) and far dot jumps are a direct cut: a smooth scroll
        // there rewinds across every slide in between, which reads as
        // "going back", not as a loop (merchant 17.09).
        if (snapMq.matches) scrollToSlide(i, Math.abs(i - prev) === 1);
      }

      if (slidesEl) {
        slidesEl.addEventListener('scroll', function () {
          if (!snapMq.matches) return;
          const w = slidesEl.clientWidth || 1;
          const idx = Math.max(0, Math.min(slides.length - 1, Math.round(slidesEl.scrollLeft / w)));
          // A finger-driven scroll updates dots live as the halfway point
          // passes. A scrollTo() in flight must not: show() already set the
          // target, and following the position would flip the dots back to
          // the slide being left. Either way, reconcile once it settles.
          if (!programmaticScroll && idx !== current) {
            setActive(idx);
            resetClock();
          }
          window.clearTimeout(scrollSettleTimer);
          scrollSettleTimer = window.setTimeout(reconcile, 140);
        }, { passive: true });
        // Auto-rotation waits while a finger is on the carousel, and a touch
        // takes over from a scrollTo() in flight. Snap mode only — above
        // 980px a tap must not touch the rotation clock.
        slidesEl.addEventListener('touchstart', function () {
          if (!snapMq.matches) return;
          userTouching = true;
          programmaticScroll = false;
        }, { passive: true });
        const touchDone = function () {
          const was = userTouching;
          userTouching = false; // unconditional: can never stick
          if (was && snapMq.matches) resetClock();
        };
        slidesEl.addEventListener('touchend', touchDone, { passive: true });
        slidesEl.addEventListener('touchcancel', touchDone, { passive: true });
        // The off-screen slides' images are lazy and clipped by the scroller;
        // have them ready by the first swipe without competing with the LCP
        // image at script start (the load+1200ms warm-up below still runs).
        slidesEl.addEventListener('touchstart', function () {
          slides.forEach(loadSlideImages);
        }, { once: true, passive: true });
      }
      if (snapMq.addEventListener) {
        snapMq.addEventListener('change', function () {
          setActive(current);
          if (snapMq.matches) scrollToSlide(current, false);
          else if (slidesEl) slidesEl.scrollLeft = 0;
        });
      }
      // Initial state for snap mode (inert on the off-screen slides). No image
      // warm-up here: slide 1 is server-rendered eager, slide 2 must not
      // compete with the LCP image at script start.
      if (snapMq.matches) setActive(0, false);
      updatePeeks(0);
      if (wideMq.addEventListener) {
        wideMq.addEventListener('change', function () { updatePeeks(current); });
      }
      peeks.forEach(function (peek, idx) {
        peek.addEventListener('click', function () {
          if (current === idx) return;
          show(idx);
          resetClock();
        });
      });

      function go(delta) {
        const i = (current + delta + slides.length) % slides.length;
        show(i);
      }

      // ---- Single-clock rotation (rewrite 11.06) ----
      // The old design ran TWO independent clocks: a CSS keyframe animation
      // for the dot's progress fill (paused by :hover, restarted only when
      // aria-current moved) and a setInterval for the actual slide advance
      // (cleared on mouseenter/focusin, restarted from a FULL period on
      // mouseleave). Any hover desynced them — the bar finished early and the
      // slide switched seconds later; a cursor resting on the hero (or focus
      // inside it) stopped rotation entirely while the bar sat full; background
      // tabs throttled the interval. One rAF clock now drives BOTH: it
      // accumulates elapsed time, writes the fill progress to --dot-progress
      // (consumed by the dot ::after transform), and advances at 100%. Pauses
      // (keyboard focus, offscreen, hidden tab) freeze bar + advance together,
      // so they can never drift apart.
      let elapsed = 0;
      let lastTick = null;
      let rafId = null;

      function rotationBlocked() {
        // Deliberately NOT gated on prefers-reduced-motion (overriding the
        // audit-2026-06 A11Y-1 decision, user 11.06): the signal is overly
        // broad on Windows — "animation effects off" sets it, often
        // unintentionally — and it froze the hero on the merchant's own
        // machines ("bar instantly full, never switches"), same story as the
        // announcement marquee before (be7fd4d). The slide swap itself is a
        // non-animated display toggle, decorative hero animations stay
        // disabled under reduced motion via the CSS @media rules, and users
        // keep pause control through the arrows/dots + the keyboard-focus
        // pause — which serves WCAG 2.2.2's intent better than a dead hero.
        return !autoRotate;
      }

      function setProgress(fraction) {
        hero.style.setProperty('--dot-progress', String(Math.min(1, fraction)));
      }

      function resetClock() {
        elapsed = 0;
        setProgress(0);
      }

      function tick(now) {
        if (rotationBlocked()) {
          // Full bar doubles as the static "selected" marker; loop parks
          // itself (the reduced-motion listener below restarts it).
          setProgress(1);
          rafId = null;
          return;
        }
        const paused = keyboardFocusInside || offscreen || document.hidden || userTouching;
        if (!paused) {
          if (lastTick !== null) {
            // Clamp the per-frame delta: a background tab or a long main-thread
            // stall must nudge the clock, not teleport it past a full period.
            elapsed += Math.min(now - lastTick, 100);
          }
          if (elapsed >= rotationMs) {
            elapsed = 0;
            go(1);
          }
          setProgress(elapsed / rotationMs);
        }
        lastTick = now;
        rafId = window.requestAnimationFrame(tick);
      }

      function startLoop() {
        if (rafId === null) {
          lastTick = null;
          rafId = window.requestAnimationFrame(tick);
        }
      }

      if (prev) prev.addEventListener('click', function () { go(-1); resetClock(); });
      if (next) next.addEventListener('click', function () { go(1); resetClock(); });
      dots.forEach(function (dot, idx) {
        dot.addEventListener('click', function () {
          if (current === idx) return;
          show(idx);
          resetClock();
        });
      });

      // Keyboard users: pause while focus is inside the hero — otherwise the
      // focused CTA's slide flips to display:none on auto-advance and focus
      // falls back to <body>. Resume when focus leaves (audit-2026-06 A11Y-1).
      // Gated to :focus-visible (keyboard focus): a mouse click on an arrow
      // or dot also focuses it, and an ungated focusin froze the rotation
      // until the user happened to click outside the hero.
      hero.addEventListener('focusin', function (e) {
        let kb = true;
        try { kb = e.target.matches(':focus-visible'); } catch (err) { /* old engines: treat as keyboard */ }
        if (kb) keyboardFocusInside = true;
      });
      hero.addEventListener('focusout', function (e) {
        if (!hero.contains(e.relatedTarget)) keyboardFocusInside = false;
      });


      // Touch swipe with drag-follow feedback. The active slide
      // translates with the finger during the gesture so the user can
      // SEE the slide is responding. On release: if the drag passed the
      // threshold, advance / go back; otherwise snap back to centre.
      const SWIPE_THRESHOLD_PX = 50;
      const DRAG_DAMP = 0.85; // 1.0 = follows finger 1:1, lower = "resistant"
      let touchStartX = null;
      let touchStartY = null;
      let touchActive = false;
      let touchSlide = null;

      function getActiveSlide() {
        return hero.querySelector('[data-hero-slide][aria-hidden="false"]');
      }

      function clearSlideTransform(slide) {
        if (!slide) return;
        slide.style.transition = '';
        slide.style.transform = '';
        slide.style.opacity = '';
      }

      function snapBack(slide) {
        if (!slide) return;
        slide.style.transition = 'transform 0.22s ease, opacity 0.22s ease';
        slide.style.transform = '';
        slide.style.opacity = '';
        window.setTimeout(function () {
          slide.style.transition = '';
        }, 240);
      }

      hero.addEventListener('touchstart', function (e) {
        // ≤980px is native scroll-snap (see above); this drag-follow gesture
        // only serves touch screens wider than that (tablets in landscape).
        if (snapMq.matches || e.touches.length !== 1) {
          touchStartX = null;
          return;
        }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = false;
        touchSlide = getActiveSlide();
        if (touchSlide) touchSlide.style.transition = '';
      }, { passive: true });

      hero.addEventListener('touchmove', function (e) {
        if (touchStartX === null || !touchSlide) return;
        const dx = e.touches[0].clientX - touchStartX;
        const dy = e.touches[0].clientY - touchStartY;
        // Lock direction once we've moved enough to know.
        if (!touchActive) {
          if (Math.abs(dy) > Math.abs(dx) || Math.abs(dx) < 8) return;
          touchActive = true;
        }
        const move = dx * DRAG_DAMP;
        touchSlide.style.transform = 'translateX(' + move + 'px)';
        touchSlide.style.opacity = String(Math.max(0.6, 1 - Math.abs(dx) / 700));
      }, { passive: true });

      hero.addEventListener('touchend', function (e) {
        if (touchStartX === null) {
          touchSlide = null;
          return;
        }
        const dx = e.changedTouches[0].clientX - touchStartX;
        const slide = touchSlide;
        const committed = touchActive && Math.abs(dx) >= SWIPE_THRESHOLD_PX;
        touchStartX = null;
        touchStartY = null;
        touchActive = false;
        touchSlide = null;

        if (committed) {
          // Slide off in the swipe direction, then swap. The new active
          // slide enters from translateX(0) (its default state), which
          // alongside the brief fade-out of the old slide reads as a
          // crossfade with directional intent.
          if (slide) {
            slide.style.transition = 'transform 0.18s ease-out, opacity 0.18s ease-out';
            slide.style.transform = 'translateX(' + (dx < 0 ? -60 : 60) + 'px)';
            slide.style.opacity = '0';
          }
          window.setTimeout(function () {
            go(dx < 0 ? 1 : -1);
            clearSlideTransform(slide);
            resetClock();
          }, 180);
        } else {
          snapBack(slide);
        }
      }, { passive: true });

      hero.addEventListener('touchcancel', function () {
        snapBack(touchSlide);
        touchStartX = null;
        touchStartY = null;
        touchActive = false;
        touchSlide = null;
      }, { passive: true });

      startLoop();

      // Safety net: once the critical load is done, queue every slide's images
      // (lazy → eager) so no slide is ever blank when the carousel reaches it,
      // without competing with the LCP image up front.
      function warmAllSlideImages() { slides.forEach(loadSlideImages); }
      if (document.readyState === 'complete') {
        window.setTimeout(warmAllSlideImages, 1200);
      } else {
        window.addEventListener('load', function () {
          window.setTimeout(warmAllSlideImages, 1200);
        });
      }
    });
  })();

  // Game-logo tint is manual-only: set `logo_tint` per slide in the section
  // editor. It feeds --logo-tint on the slide → the .hero__meta::before
  // gradient + .hero__art-glow halo. When unset, the @property default (cream)
  // applies. The former auto-extraction (a canvas pixel-averaging pass over
  // each logo, with a localStorage cache + CORS handling) was removed in the
  // hero audit: manual tints are simpler, avoid the canvas/CORS work, and the
  // cream default looks fine on its own.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-giftcard"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.gc-pdp').forEach(function (root) {
      const amountBtns = root.querySelectorAll('[data-gc-amount-btn]');
      const amountDisplay = root.querySelector('[data-gc-amount-display]');
      const variantIdInput = root.querySelector('[data-gc-variant-id]');
      const priceDisplay = root.querySelector('[data-gc-price]');
      const priceButton = root.querySelector('[data-gc-price-button]');
      const recipientForm = root.querySelector('recipient-form');
      const recipientDisplay = root.querySelector('[data-gc-recipient-display]');

      // Amount picker — updates variant id, card preview number, submit total.
      amountBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          amountBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (variantIdInput) variantIdInput.value = btn.dataset.variantId;
          // Keep recipient-form.js's tracked variant id in sync with the chosen
          // amount, so its inline-error / reset path matches the posted variant
          // (otherwise a recipient validation error on a non-default amount is silent).
          if (recipientForm && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
            publish(PUB_SUB_EVENTS.variantChange, {
              data: { sectionId: recipientForm.dataset.sectionId, variant: { id: btn.dataset.variantId } },
            });
          }
          if (amountDisplay) amountDisplay.textContent = btn.dataset.amountDisplay;
          // amountFormatted comes from `variant.price | money | escape`. Shopify's
          // money_format on this store wraps prices in <span class="money">…</span>,
          // so textContent would dump that literal markup on screen. innerHTML re-
          // parses the escape into a real DOM span (matches the initial Liquid
          // render which already emits the same wrapper).
          if (priceDisplay) priceDisplay.innerHTML = btn.dataset.amountFormatted;
          if (priceButton) priceButton.innerHTML = btn.dataset.amountFormatted;
        });
      });

      // Recipient name -> live preview on the card. The name input lives
      // inside Dawn's recipient-form (revealed by the gift checkbox), so we
      // delegate from the form element and match the standard property name.
      if (recipientForm && recipientDisplay) {
        recipientForm.addEventListener('input', function (evt) {
          if (evt.target && evt.target.name === 'properties[Recipient name]') {
            const val = evt.target.value.trim();
            recipientDisplay.textContent = val ? val : '—';
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
